import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  LinearProgress,
  Chip,
  Stack,
  CardActions,
  Tooltip,
  IconButton,
} from "@mui/material";
import AssignmentIcon from '@mui/icons-material/Assignment';
import axios from "axios";
import { BASE_URL } from "../Utils/Baseurl";


const CustomLinearProgress = ({ value, height = 7, backgroundColor = "#e0e0e0", fillColor = "green" }) => {
  // Clamp the value between 0 and 100
  const safeValue = Math.min(100, Math.max(0, value));

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: backgroundColor,
        borderRadius: "8px",
        overflow: "hidden",
        height: `${height}px`,
      }}
    >
      <div
        style={{
          width: `${safeValue}%`,
          backgroundColor: fillColor,
          height: "100%",
          transition: "width 0.3s ease-in-out",
        }}
      />
    </div>
  );
};


const TaskRow = ({ task }) => {
  if (!task) {
    return (
      <Box
        sx={{
          p: 1,
          textAlign: "center",
          color: "#999",
          fontSize: "12px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        No task found. Create a task to see details here.
      </Box>
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        p: 1,
        borderBottom: "1px solid #e0e0e0",
        "&:hover": { backgroundColor: "#f5f5f5" },
      }}
    >
      {/* Task Name */}
      <Typography sx={{ minWidth: 150, fontSize: "10px", fontWeight: 500 }}>
        {task.taskname}
      </Typography>

      {/* Task Code */}
      <Typography sx={{ minWidth: 80, fontSize: "10px" }}>
        {task.taskcode}
      </Typography>

      {/* Employee */}
      <Typography sx={{ minWidth: 150, fontSize: "10px" }}>
        {task.employee}
      </Typography>

      {/* Allocated Dates */}
      <Typography sx={{ minWidth: 120, fontSize: "10px" }}>
        {task.allocated_start_date} → {task.allocated_end_date}
      </Typography>

      {/* Actual Dates */}
      <Typography sx={{ minWidth: 120, fontSize: "10px", color: task.actual_start_date ? "#000" : "#999" }}>
        {task.actual_start_date ?? "-"} → {task.actual_end_date ?? "-"}
      </Typography>

      {/* Allocated Work Hours */}
      <Typography sx={{ minWidth: 80, fontSize: "10px" }}>
        {task.allocated_work_hr} hr
      </Typography>

      {/* Actual Work Hours */}
      <Typography sx={{ minWidth: 80, fontSize: "10px" }}>
        {task.actual_work_hr} hr
      </Typography>

      {/* Priority */}
      <Chip
        label={task.priority}
        size="small"
        color={task.priority === "Critical" ? "error" : "warning"}
        sx={{ minWidth: 70 }}
      />

      {/* Status */}
      <Chip
        label={task.status}
        size="small"
        color={task.status === "Completed" ? "success" : "default"}
        sx={{ minWidth: 90 }}
      />
    </Box>
  );
};

const ProjectDashboardCards = ({ phase }) => {

  console.log(phase, 'phase')

  const [open, setOpen] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [mileStoneData, setMileStoneData] = useState([]);


  useEffect(() => {
    if (selectedMilestone) {
      fetchMilestoneData(selectedMilestone);
    }
  }, [selectedMilestone]);

  const handleMilestoneClick = (milestoneId) => {
    setSelectedMilestone(milestoneId);
  };


/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Fetches a list of tasks from the API and updates the state with the retrieved data.
 * Retrieves the authentication token from session storage and includes it in the request headers.
 * Upon successful response, sets the mileStoneData state with the fetched data.
 * Logs any errors encountered during the fetch operation.
 * @param {number} milestoneId - id of the milestone to be fetched
 */
/*******  da8d7ad3-af4f-4163-b995-524af0ae267f  *******/  const fetchMilestoneData = async (milestoneId) => {
    try {
      const response = await axios.get(`${BASE_URL}api/milestones/${milestoneId}/tasks/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      )
      setMileStoneData(response.data.data);

    } catch (err) {
      console.error("Error fetching milestone data:", err);
    }
  }

  return (
    <>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 3,
          width: 300, // 🔹 fixed width
          height: 168, // 🔹 fixed height
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          bgcolor: phase.bgColor,
          borderTop: `5px solid ${phase.color}`,
        }}
      >
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            p: 1.5, // padding inside child
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 0.5,
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              {phase.milestone_name}
            </Typography>
            <Chip
              label={phase?.status}
              size="small"
              sx={{
                bgcolor: "#fff3e0",
                border: "1px solid #ff9800",
                color: "#ff9800",
                fontWeight: "bold",
                fontSize: "0.65rem",
                height: 20,
              }}
            />
          </Box>
          <Box sx={{ width: "50%", bgcolor: "#e0e0e0", height: 5, borderRadius: 5, }}>
            {/* <LinearProgress
              variant="determinate"
              value={Number(phase.milestone_completion_percentage)}
              sx={{
                height: 5,
                width: "50%",
                "& .MuiLinearProgress-bar": {
                  bgcolor: phase.color,
                },
                mb: 1,
              }}
            /> */}
            <CustomLinearProgress value={parseInt(phase.milestone_completion_percentage)} />
          </Box>  
          <Box sx={{ display: "flex", alignItems: "center", pt: 2 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 2,
                bgcolor: "#fff",
                border: `1.5px solid ${phase.color}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 4,
              }}
            >
              <IconButton
                aria-label="assignment"
                size="small"
                sx={{ width: 36, height: 36 }}
              >
                <AssignmentIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Box>

            <Stack direction="row" spacing={-0.4}>
              {phase.milestone_resource_list.slice(0, 3).map((member, index) => (
                <Tooltip key={index} title={member.resource || ""} arrow>
                  <Avatar
                    sx={{
                      width: 26,
                      height: 26,
                      border: "1.5px solid white",
                      fontSize: "12px",
                      bgcolor: "#2D5F99"
                    }}
                    src={member.image || ""}
                  >
                    {!member.image && member.resource
                      ? member.resource.charAt(0).toUpperCase()
                      : ""}
                  </Avatar>
                </Tooltip>
              ))}

              {phase.milestone_resource_list.length > 3 && (
                <Tooltip title={`${phase.milestone_resource_list.length - 3} more employees`} arrow>
                  <Avatar
                    sx={{
                      width: 26,
                      height: 26,
                      border: "1.5px solid white",
                      fontSize: "12px",
                      bgcolor: "#E0E0E0",
                      color: "#2D5F99"
                    }}
                  >
                    +{phase.milestone_resource_list.length - 3}
                  </Avatar>
                </Tooltip>
              )}
            </Stack>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: "10px" }}>
            <Typography variant="caption" color="text.secondary">
              Start: {phase.start_date}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              End: {phase.end_date}
            </Typography>
          </Box>
          <CardActions>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: '5px', cursor: "pointer" }}
              onClick={() => {
                setOpen(true);
                handleMilestoneClick(phase.milestone_id);
              }}>
              <Typography variant="caption" color="text.secondary">View task details</Typography>
            </Box>
          </CardActions>
        </CardContent>
      </Card>


      {open && (
        <Box
          onClick={() => setOpen(false)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0,0,0,0.3)",
            zIndex: 1200,
          }}
        />
      )}

      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100%",
          width: 700,
          bgcolor: "background.paper",
          boxShadow: "-2px 0 8px rgba(0,0,0,0.2)",
          zIndex: 1300,
          p: 2,
          overflowY: "auto",
          overflowX: "hidden",
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease-in-out",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <Typography variant="h6" fontWeight='bold' gutterBottom>
          Task Details
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            maxHeight: "400px",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
            border: "1px solid #e0e0e0",
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              p: 1,
              fontWeight: "bold",
              borderBottom: "1px solid #ccc",
              backgroundColor: "#f0f0f0",
            }}
          >
            <Typography sx={{ minWidth: 150, fontSize: "12px", fontWeight: 'bold' }}>Task Name</Typography>
            <Typography sx={{ minWidth: 80, fontSize: "12px", fontWeight: 'bold' }}>Task Code</Typography>
            <Typography sx={{ minWidth: 150, fontSize: "12px", fontWeight: 'bold' }}>Employee</Typography>
            <Typography sx={{ minWidth: 120, fontSize: "12px", fontWeight: 'bold' }}>Allocated Dates</Typography>
            <Typography sx={{ minWidth: 120, fontSize: "12px", fontWeight: 'bold' }}>Actual Dates</Typography>
            <Typography sx={{ minWidth: 80, fontSize: "12px", fontWeight: 'bold' }}>Allocated Hr</Typography>
            <Typography sx={{ minWidth: 80, fontSize: "12px", fontWeight: 'bold' }}>Actual Hr</Typography>
            <Typography sx={{ minWidth: 70, fontSize: "12px", fontWeight: 'bold' }}>Priority</Typography>
            <Typography sx={{ minWidth: 90, fontSize: "12px", fontWeight: 'bold' }}>Status</Typography>
          </Box>

          {mileStoneData?.task_details?.map((task, index) => (
            <TaskRow key={index} task={task} />
          ))}
        </Box>

      </Box>
    </>
  );
};

export default ProjectDashboardCards;

